// import {
//   collection,
//   query,
//   where,
//   addDoc,
//   getDocs,
//   onSnapshot,
//   serverTimestamp,
//   orderBy,
//   writeBatch,
// } from "firebase/firestore";
// import { db } from "../config/firebase";
// import { GETCOUNT } from "../Redux/actions/ChatActions";

// /**
//  * Creates a chat room if one does not already exist between the specified patient and doctor.
//  * @param {string} patientID - The ID of the patient.
//  * @param {string} doctorID - The ID of the doctor.
//  * @returns {Promise<string>} - The chat room ID.
//  */
// export async function createChatRoom(patientID, doctorID) {
//   const chatsRef = collection(db, "chats");

//   // Check if a chat already exists between these users
//   const q = query(chatsRef, where("users", "array-contains", patientID));
//   const chatSnapshot = await getDocs(q);

//   const existingChat = chatSnapshot.docs.find((doc) =>
//     doc.data().users.includes(doctorID)
//   );

//   if (existingChat) {
//     return existingChat.id; // Return existing chat room ID
//   }

//   // Create a new chat room
//   const newChat = await addDoc(chatsRef, {
//     users: [patientID, doctorID],
//     createdAt: new Date(),
//   });

//   return newChat.id; // Return new chat room ID
// }

// export function getChatList(userID, setChatList) {
//   const chatsRef = collection(db, "messages");
//   const q = query(chatsRef, where("users", "array-contains", userID));

//   onSnapshot(q, (snapshot) => {
//     const chats = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//     setChatList(chats);
//   });
// }

// export async function sendMessage(senderID, recipientID, text) {
//   const messagesRef = collection(db, "messages");
//   await addDoc(messagesRef, {
//     senderID,
//     recipientID,
//     text,
//     timestamp: serverTimestamp(),
//     seen: false,
//   });
// }

// // export function listenForDoctorsList(patientID, setDoctorsList) {
// //   if (!patientID) return;

// //   const messagesRef = collection(db, "messages");

// //   // Query messages where the patient is the sender
// //   const q = query(
// //     messagesRef,
// //     where("senderID", "==", patientID),
// //   );

// //   const unsubscribe = onSnapshot(q, (snapshot) => {
// //     // Extract unique doctor IDs from messages
// //     const doctorIdsSet = new Set(
// //       snapshot.docs.map(doc => doc.data().recipientID) // Doctors are recipients
// //     );

// //     // Convert Set to an array
// //     const doctorIds = Array.from(doctorIdsSet);

// //     // Set doctor list
// //     setDoctorsList(doctorIds);
// //   });

// //   // Return cleanup function
// //   return () => {
// //     unsubscribe();
// //   };
// // }

// export function listenForDoctorsList(patientID, setDoctorsList) {
//   if (!patientID) return;

//   const messagesRef = collection(db, "messages");

//   // Query messages where the patient is either the sender or recipient
//   const q = query(
//     messagesRef,
//     where("senderID", "==", patientID) // Messages sent by the patient
//   );

//   const q2 = query(
//     messagesRef,
//     where("recipientID", "==", patientID) // Messages received by the patient
//   );

//   // Listen to both queries
//   const unsubscribe1 = onSnapshot(q, (snapshot) =>
//     updateDoctorList(snapshot, setDoctorsList)
//   );
//   const unsubscribe2 = onSnapshot(q2, (snapshot) =>
//     updateDoctorList(snapshot, setDoctorsList)
//   );

//   function updateDoctorList(snapshot, setDoctorsList) {
//     snapshot.docs.forEach((doc) => {
//       const data = doc.data();
//       const doctorID =
//         data.senderID === patientID ? data.recipientID : data.senderID;
//       setDoctorsList((prev) => [...new Set([...prev, doctorID])]); // Add unique doctor IDs
//     });
//   }

//   // Cleanup function to unsubscribe both listeners
//   return () => {
//     unsubscribe1();
//     unsubscribe2();
//   };
// }

// export function listenForMessages(user1ID, user2ID, setMessages) {
//   const messagesRef = collection(db, "messages");

//   // Firestore doesn't support querying both senderID and recipientID using `in` together.
//   // We need to perform separate checks for both sender and recipient
//   const q = query(
//     messagesRef,
//     where("senderID", "==", user1ID),
//     where("recipientID", "==", user2ID),
//     orderBy("timestamp")
//   );

//   const q2 = query(
//     messagesRef,
//     where("senderID", "==", user2ID),
//     where("recipientID", "==", user1ID),
//     orderBy("timestamp")
//   );

//   // Combine both queries with `onSnapshot` listeners
//   const unsubscribe1 = onSnapshot(q, (snapshot) => {
//     const messages = snapshot.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(),
//     }));
//     setMessages((prevMessages) => {
//       const existingMessageIds = prevMessages.map((msg) => msg.id);
//       const filteredMessages = messages.filter(
//         (msg) => !existingMessageIds.includes(msg.id)
//       );
//       return [...prevMessages, ...filteredMessages]; // Add new messages to the bottom
//     });
//   });

//   const unsubscribe2 = onSnapshot(q2, (snapshot) => {
//     const messages = snapshot.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(),
//     }));
//     setMessages((prevMessages) => {
//       const existingMessageIds = prevMessages.map((msg) => msg.id);
//       const filteredMessages = messages.filter(
//         (msg) => !existingMessageIds.includes(msg.id)
//       );
//       return [...prevMessages, ...filteredMessages]; // Add new messages to the bottom
//     });
//   });

//   // Return cleanup function
//   return () => {
//     unsubscribe1();
//     unsubscribe2();
//   };
// }

// export async function markMessagesAsSeen(recipientID, senderID) {
//   const messagesRef = collection(db, "messages");

//   // Query for messages where the recipient is the current user and `seen` is false
//   const q = query(
//     messagesRef,
//     where("recipientID", "==", recipientID),
//     where("senderID", "==", senderID),
//     where("seen", "==", false)
//   );

//   const querySnapshot = await getDocs(q);
//   const batch = writeBatch(db);

//   // Add all messages to the batch
//   querySnapshot.forEach((doc) => {
//     batch.update(doc.ref, { seen: true });
//   });

//   // Commit the batch
//   await batch.commit();
// }

// export async function countUnreadMessages(userID, onCountChange) {
//   const messagesRef = collection(db, "messages");

//   // Query for messages where the recipient is the user and `seen` is false
//   const q = query(
//     messagesRef,
//     where("recipientID", "==", userID),
//     where("seen", "==", false)
//   );

//   // const querySnapshot = await getDocs(q);

//   // Return the count of unread messages
//   // return querySnapshot.size;
//   return onSnapshot(q, (snapshot) => {
//     onCountChange(snapshot.size);
//   });
// }

// export async function countUnreadMessagesByPatient(userID) {
//   const messagesRef = collection(db, "messages");

//   // Query for unread messages where the user is the recipient
//   const q = query(
//     messagesRef,
//     where("recipientID", "==", userID),
//     where("seen", "==", false)
//   );

//   const querySnapshot = await getDocs(q);

//   // Create a map to store unread message counts per doctor
//   const unreadCounts = {};

//   querySnapshot.forEach((doc) => {
//     const senderID = doc.data().senderID;
//     unreadCounts[senderID] = (unreadCounts[senderID] || 0) + 1;
//   });

//   return unreadCounts; // Returns an object: { doctorID1: count, doctorID2: count, ... }
// }

// export function listenUnreadMessagesByPatient(userID, onChange) {
//   const messagesRef = collection(db, "messages");

//   const q = query(
//     messagesRef,
//     where("recipientID", "==", userID),
//     where("seen", "==", false)
//   );

//   return onSnapshot(q, (snapshot) => {
//     const unreadCounts = {};

//     snapshot.forEach((doc) => {
//       const senderID = doc.data().senderID;
//       unreadCounts[senderID] = (unreadCounts[senderID] || 0) + 1;
//     });

//     onChange(unreadCounts);
//   });
// }


// version -2

import {
  collection,
  query,
  where,
  addDoc,
  getDocs,
  onSnapshot,
  serverTimestamp,
  orderBy,
  writeBatch,
} from "firebase/firestore";
import { db } from "../config/firebase";

/**
 * Creates a chat room if one does not already exist between the specified patient and doctor.
 * @param {string} patientID - The ID of the patient.
 * @param {string} doctorID - The ID of the doctor.
 * @returns {Promise<string>} - The chat room ID.
 */
export async function createChatRoom(patientID, doctorID) {
  const chatsRef = collection(db, "chats");

  const q = query(chatsRef, where("users", "array-contains", patientID));
  const chatSnapshot = await getDocs(q);

  const existingChat = chatSnapshot.docs.find((doc) =>
    doc.data().users.includes(doctorID)
  );

  if (existingChat) {
    return existingChat.id;
  }

  const newChat = await addDoc(chatsRef, {
    users: [patientID, doctorID],
    createdAt: new Date(),
  });

  return newChat.id;
}

export function getChatList(userID, setChatList) {
  const chatsRef = collection(db, "messages");
  const q = query(chatsRef, where("users", "array-contains", userID));

  return onSnapshot(q, (snapshot) => {
    const chats = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setChatList(chats);
  });
}

export async function sendMessage(senderID, recipientID, text) {
  const messagesRef = collection(db, "messages");
  const docRef = await addDoc(messagesRef, {
    senderID,
    recipientID,
    text,
    timestamp: serverTimestamp(),
    seen: false,
  });
  // Return the new message id so callers can optimistically render it
  // without re-subscribing or re-querying.
  return docRef.id;
}

/**
 * Listens for the set of doctor IDs a patient has exchanged messages with.
 *
 * FIX vs original: the previous version called setDoctorsList() once per
 * document inside each snapshot (forEach), which meant a conversation with
 * 50 messages triggered up to 50 redundant state updates per snapshot fired.
 * This version computes the unique doctor-id set once per snapshot and
 * commits a single state update, merging both the "sent" and "received"
 * snapshots' most recent results.
 */
export function listenForDoctorsList(patientID, setDoctorsList) {
  if (!patientID) return () => {};

  const messagesRef = collection(db, "messages");

  const sentQuery = query(messagesRef, where("senderID", "==", patientID));
  const receivedQuery = query(
    messagesRef,
    where("recipientID", "==", patientID)
  );

  // Keep the latest known doctor-ids derived from each query independently,
  // then merge, so one query's snapshot never wipes out the other's data.
  let sentDoctorIds = new Set();
  let receivedDoctorIds = new Set();

  const commit = () => {
    const merged = new Set([...sentDoctorIds, ...receivedDoctorIds]);
    setDoctorsList(Array.from(merged));
  };

  const unsubscribeSent = onSnapshot(sentQuery, (snapshot) => {
    sentDoctorIds = new Set(
      snapshot.docs.map((doc) => doc.data().recipientID)
    );
    commit();
  });

  const unsubscribeReceived = onSnapshot(receivedQuery, (snapshot) => {
    receivedDoctorIds = new Set(
      snapshot.docs.map((doc) => doc.data().senderID)
    );
    commit();
  });

  return () => {
    unsubscribeSent();
    unsubscribeReceived();
  };
}

/**
 * Listens for messages between two users.
 *
 * FIX vs original: dedup used prevMessages.map(...).includes(...) inside a
 * filter — O(n^2) per snapshot, run twice (once per query), every time
 * either listener fired. This version keeps a Map keyed by doc id internally
 * and only republishes a freshly-sorted array when something actually
 * changed, which is O(n) and avoids redundant re-renders.
 */
export function listenForMessages(user1ID, user2ID, setMessages) {
  const messagesRef = collection(db, "messages");

  const q1 = query(
    messagesRef,
    where("senderID", "==", user1ID),
    where("recipientID", "==", user2ID),
    orderBy("timestamp")
  );

  const q2 = query(
    messagesRef,
    where("senderID", "==", user2ID),
    where("recipientID", "==", user1ID),
    orderBy("timestamp")
  );

  // Single source of truth for "what messages exist", shared by both
  // listeners, so we never duplicate or quadratically re-scan.
  const messagesById = new Map();

  const publish = () => {
    const sorted = Array.from(messagesById.values()).sort(
      (a, b) => (a.timestamp?.toMillis?.() ?? 0) - (b.timestamp?.toMillis?.() ?? 0)
    );
    setMessages(sorted);
  };

  const handleSnapshot = (snapshot) => {
    let changed = false;
    snapshot.docChanges().forEach((change) => {
      if (change.type === "removed") {
        if (messagesById.delete(change.doc.id)) changed = true;
      } else {
        messagesById.set(change.doc.id, {
          id: change.doc.id,
          ...change.doc.data(),
        });
        changed = true;
      }
    });
    if (changed) publish();
  };

  const unsubscribe1 = onSnapshot(q1, handleSnapshot);
  const unsubscribe2 = onSnapshot(q2, handleSnapshot);

  return () => {
    unsubscribe1();
    unsubscribe2();
  };
}

export async function markMessagesAsSeen(recipientID, senderID) {
  const messagesRef = collection(db, "messages");

  const q = query(
    messagesRef,
    where("recipientID", "==", recipientID),
    where("senderID", "==", senderID),
    where("seen", "==", false)
  );

  const querySnapshot = await getDocs(q);
  if (querySnapshot.empty) return;

  const batch = writeBatch(db);
  querySnapshot.forEach((doc) => {
    batch.update(doc.ref, { seen: true });
  });

  await batch.commit();
}

export async function countUnreadMessages(userID, onCountChange) {
  const messagesRef = collection(db, "messages");

  const q = query(
    messagesRef,
    where("recipientID", "==", userID),
    where("seen", "==", false)
  );

  return onSnapshot(q, (snapshot) => {
    onCountChange(snapshot.size);
  });
}

export async function countUnreadMessagesByPatient(userID) {
  const messagesRef = collection(db, "messages");

  const q = query(
    messagesRef,
    where("recipientID", "==", userID),
    where("seen", "==", false)
  );

  const querySnapshot = await getDocs(q);
  const unreadCounts = {};

  querySnapshot.forEach((doc) => {
    const senderID = doc.data().senderID;
    unreadCounts[senderID] = (unreadCounts[senderID] || 0) + 1;
  });

  return unreadCounts;
}

export function listenUnreadMessagesByPatient(userID, onChange) {
  const messagesRef = collection(db, "messages");

  const q = query(
    messagesRef,
    where("recipientID", "==", userID),
    where("seen", "==", false)
  );

  return onSnapshot(q, (snapshot) => {
    const unreadCounts = {};
    snapshot.forEach((doc) => {
      const senderID = doc.data().senderID;
      unreadCounts[senderID] = (unreadCounts[senderID] || 0) + 1;
    });
    onChange(unreadCounts);
  });
}
